module.exports = __webpack_public_path__ + "img/1-1-1.f4de28db.png";